import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const objections = [{
  question: '¿Y si no tengo experiencia?',
  answer: 'Perfecto. El manual empieza desde cero y te muestra habilidades simples que empresas ya están pagando en dólares.'
}, {
  question: '¿Y si no sé inglés?',
  answer: 'Muchos freelancers trabajan completamente en español con clientes de EE.UU. y empresas hispanas.'
}, {
  question: '¿Y si esto es muy complicado?',
  answer: 'El manual tiene solo 20 páginas y un plan de acción claro para conseguir tu primer pago en 14 días.'
}];
export function ObjectionsSection() {
  return <section className="py-24 px-4 bg-[#0A0A0A] relative overflow-hidden" data-id="element-40">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A84C]/30 to-transparent" data-id="element-41" />

      <div className="max-w-3xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-43">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-44">
            Tal vez estás pensando{' '}
            <span className="text-[#C9A84C]" data-id="element-45">algo como esto…</span>
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-46">
          {objections.map((obj, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15,
          duration: 0.5
        }} className="bg-[#0f0f0f] border border-neutral-800 rounded-2xl p-6 md:p-8" data-id="element-47">
              <div className="flex items-start gap-4" data-id="element-48">
                <div className="flex-shrink-0 p-2.5 bg-[#1A7A4A]/10 rounded-lg border border-[#1A7A4A]/20" data-id="element-49">
                  <CheckCircle2Icon className="w-5 h-5 text-[#1A7A4A]" data-id="element-50" />
                </div>
                <div data-id="element-51">
                  <p className="text-lg font-bold text-white mb-2 italic" data-id="element-52">
                    "{obj.question}"
                  </p>
                  <p className="text-[#D1D5DB] text-base leading-relaxed" data-id="element-53">
                    {obj.answer}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}